import React, { useState, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import action from "../../Redux Store/actions";
import cssClasses from "./Settings.module.css";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import Button from "../../Subcomponents/Button";
import DropDown from "../../Subcomponents/DropDown";
import Info from "../../Components/Icons/RejectedIcon";
import PlusIcon from "../Icons/PlusIcon";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
// Modal
import AddDropDownList from "../../Modals/AddDropDownList/AddDropDownList";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import { DataGrid } from "@mui/x-data-grid";
import Checkbox from '@mui/material/Checkbox';

// Service
import {
  deleteNationality,
  deleteNative,
  deleteWorksIn,
  deleteBudget,
  getAppForSlotBooking,
  getBlackListedPhoneNumber,
  getCustomerPaymentMethod,
  getFormatedEmail,
  getNationality,
  getNative,
  getWorksIn,
  getBudget,
  updateCustomerPaymentMethod,
  updateFormatedEmail,
} from "../../Services/Settings";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";
import { errorTost, successTost } from "../../Services/Toast";
import CustomInput from "../../Subcomponents/CustomInput";
import {
  Box,
  FormControlLabel,
  FormGroup,
  Tooltip,
} from "@mui/material";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../Icons/Dot";
import CustomRadio from "../../Subcomponents/CustomRadio";
import CustomSwitch from "../../Subcomponents/CustomSwitch";
const useStyles = makeStyles((theme) => ({
  radioLabel: {
    fontFamily: "Inter-Medium !important",
    fontSize: "1.6rem",
    lineHeight: "2.5rem",
  },
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  TextFieldStyle: {
    width: "100%",
    background: "#F2F4F7 !important",
    paddingRight: "0rem !important",
    borderRadius: "10px !important",
    fontSize: "1.6rem !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "2.4rem !important",
  },
  inputStyle: {
    fontFamily: "Inter-Medium !important",
    paddingRight: "0rem !important",
    fontSize: "1.6rem !important",
    lineHeight: "2.4rem !important",
    background: "#F2F4F7  !important",
    //   border: '1px solid #D0D5DD',
    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    borderRadius: "10px !important",
    border: "1px solid #F2F4F7",
    "& input": {
      fontSize: "1.6rem !important",
      lineHeight: "2.4rem !important",
      color: "#101828 !important",
      padding: "1.3rem 1.4rem",
      border: "none !important",
      boxShadow: "none !important",
    },

    "& input[text]": {
      color: "#101828 !important",
    },
    "& input[input:-internal-autofill-selected]": {
      background: "#F2F4F7 !important",
    },
    "& input[value]": {
      background: "#FFFFF !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused": {
      background: "#FFFFFF !important",
      border: "1px solid #84CAFF !important",
      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF",
    },
    "&.Mui-error": {
      border: "1px solid red !important",
      boxShadow: "none !important",
    },
  },

  helperText: {
    background: "#FFFFFF !important",
    fontSize: "1.4rem !important",
    margin: "0rem 0 0 0 !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "1.8rem !important",
    paddingTop: "0.5rem !important ",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "3rem",
    lineHeight: "3.8rem",
    color: "#101828",
    marginBottom: "1.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.6rem",
    lineHeight: "2.4rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperCkeditor: {
    fontSize: "1.4em !important",
  },
  ck: {
    "&.ck.ck-editor": {
      fontSize: "1.4rem",
      marginTop: "0.6rem",
    },
  },
}));
const dataGridStyles = {
  "&.MuiDataGrid-root .MuiDataGrid-cell:focus": {
    outline: "none",
  },
  border: "1px solid #EAECF0 !important",
  fontWeight: "400",
  fontSize: "1.4rem",
  lineHeight: "2rem",
  color: "#667085",
  fontFamily: "Inter-Medium",
  borderRadius: "8px",
  '& div[data-colindex="1"]': {
    color: "#101828",
    fontWeight: "500",
  },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      borderBottom: "1px solid #EAECF0",
      background: "#FFFFFF",
      /* Shadow/xl */

      // boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
      borderRadius: "1rem",

      //   "&:nth-of-type(2n+1)": { backgroundColor: "rgba(249, 250, 251, 1)" },
      //   backgroundColor: "#FFFFFF",
    },
    "& .MuiDataGrid-row.Mui-selected:hover": {
      borderBottom: "1px solid #EAECF0",
      backgroundColor: "#FFFFFF",
      // "&:nth-of-type(2n+1)": {
      //   backgroundColor: "rgba(249, 250, 251, 1)",
      // },
    },
  },
  "& .MuiDataGrid-iconSeparator ": {
    display: "none",
  },
  "& .MuiDataGrid-columnHeader:hover": {
    "& .MuiDataGrid-menuIcon": {
      visibility: "hidden",
    },
  },

  "&  .MuiDataGrid-columnHeaders": {
    background: "#F9FAFB",
    /* Gray/200 */
    border: "1px solid #EAECF0",
    /* Shadow/xl */
    // boxShadow:
    //   "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
    // borderRadius: "8px",

    marginBottom: "1rem",
    borderBottom: "6px solid #EAECF0",
  },
  "& .MuiDataGrid-columnSeparator": {
    display: "none",
  },
  "& .MuiDataGrid-checkboxInput": {
    "& svg": {
      width: "2rem",
      height: "2rem",
      background: "#FFFFFF",
    },
  },
  // "& .MuiTablePagination-displayedRows": {
  //   display: "none",
  // },
  "& .MuiDataGrid-footerContainer": {
    "& .MuiTablePagination-displayedRows ": {
      display: "none",
    },
    "& .MuiDataGrid-selectedRowCount": {
      visibility: "hidden ",
    },
  },
  "&  [title='Sort']": {
    //visibility:"hidden",
    display: "none",
    cursor: "none",
  },
  "& [title='Go to previous page']": {
    borderRadius: "0",
    border: "1px solid #EAECF0",
    borderRadius: "0.8rem",
    marginRight: "0.5rem",
  },
  "& [title='Go to next page']": {
    borderRadius: "0",
    border: "1px solid #EAECF0",
    borderRadius: "0.8rem",
    marginRight: "0.5rem",
  },
  "& [title='Go to previous page']:after": {
    content: "'Previous'",
    marginLeft: "1rem",
  },
  "& [title='Go to next page']:before": {
    content: "'Next'",
    marginRight: "1rem",
  },
  "& .MuiDataGrid-columnHeader": {
    padding: "0 4rem",

    "&:focus": {
      outline: "none",
    },
  },
  "&  .MuiDataGrid-row ": {
    maxHeight: "72px !important",
    minHeight: "72px !important",
  },
  "& .MuiDataGrid-cell": {
    padding: "0 4rem",
    minHeight: "72px !important",
    maxHeight: "72px !important",
    "&:focus": {
      outline: "none",
    },
  },
  "& .MuiButtonBase-root": {
    fontSize: "1.6rem",
  },
  "& .MuiDataGrid-cell:focus-within": {
    outline: "none !important",
  },
};

const radioButtonStyle = {
  ".MuiFormControlLabel-label": {
    fontSize: "1.4rem",
    color: "#344054",
    lineHeight: "2rem",
    fontFamily: "Inter-Medium",
  },
};
export default function Settings() {
  let loggedInUser = {};
  const classes = useStyles();
  const dispatch = useDispatch();
  loggedInUser = useSelector((state) => state.Auth.user);
  const [tabs, setTab] = useState([
    "Lead Onboarding",
    "Pre Select Confirmation",
    "Cancel Unit",
    "Blacklist Numbers",
    "Dropdowns",
    "Customer Portal Payment",
  ]);
  const [tabValue, setTabValue] = React.useState("Lead Onboarding");
  const [leadOnBoardingMessage, setLeadOnBoardingMessage] = useState(null);
  const [leadOnBoardingSubject, setLeadOnBoardingSubject] = useState("");
  const [preSelectConfirmation, setPreSelectConfirmation] = useState(null);
  const [preSelectConfirmationSubject, setPreSelectConfirmationSubject] =
    useState("");


  const [cancelUnit, setCancelUnit] = useState(null);
  const [cancelUnitSubject, setCancelUnitSubject] = useState("");
  const [nationality, setNationality] = useState([]);
  const [native, setNative] = useState([]);
  const [budget, setBudget] = useState([]);
  const [worksIn, setWorksIn] = useState([]);
  const [helperText, setHelperText] = useState({
    leadOnBoardingMessage: "",
    preSelectConfirmation: "",
    cancelUnit: "",
  });
  const [addDropDownModal, setAddDropDownModal] = useState(false);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [displayDeleteTitle, setDisplayDeleteTitle] = useState("");
  const [displayDeleteSubTitle, setDisplayDeleteSubTitle] = useState("");
  const [data, setData] = useState(null);
  //   add or edit
  const [type, setType] = useState("Add");
  // which one is selected dropdown eg.Native,WorksIn
  const [title, setTitle] = useState(null);
  const [blackListedList, setBlackListedList] = useState([]);
  const [pageMaintain, setPageMaintain] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [communicationType, setCommunicationType] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [addedItems, setAddedItems] = useState([]);
  const [checked, setChecked] = useState(false);

  // **Type of payment Customer Payment Config Tab

  // const [customerPayment,setCustomerPayment]=useState({
  //   typeOfCustomerPayment:null,
  //   currentTypeOfCustomerPayment:null,
  //   id:null
  // });

  const [customerPayment, setCustomerPayment] = useState({
    customerPaymentForToken: false,
    customerPaymentForAllotment: false,
    customerPaymentForBalanceSdr: false,
  });
  // tablist
  const tabList = tabs.map((each, index) => {
    return (
      <Tab
        label={each}
        key={index}
        value={each}
        sx={[
          {
            fontFamily: "Inter-Medium !important",
            fontStyle: "normal !important",
            fontWeight: "500 !important",
            fontSize: "1.4rem !important",
            lineHeight: "2rem !important",
            textTransform: "none !important",
          },
        ]}
      />
    );
  });
  useEffect(() => {
    dispatch(action.activeMenu("settings"));
    getBookSlotConfig();
  }, []);

  function getBookSlotConfig() {
    getAppForSlotBooking().then((res) => {
      // console.log("--",res);
      setChecked(res?.data[0].useInAppForSlotBooking);
    }).catch((err) => {
      console.log(err);
    })
  }

  useEffect(() => {
    if (tabValue === "Lead Onboarding") {
      getFormatedEmail("Lead Onboarding")
        .then((resp) => {
          console.log("Lead Onboarding", resp);
          setLeadOnBoardingMessage(resp.data[0]?.emailTemplate || '');
          setLeadOnBoardingSubject(resp.data[0]?.emailSubject || '');
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (tabValue === "Pre Select Confirmation") {
      getFormatedEmail("Pre Select Confirmation")
        .then((resp) => {
          console.log("Pre Select Confirmation", resp);
          setPreSelectConfirmation(resp.data[0].emailTemplate);
          setPreSelectConfirmationSubject(resp.data[0].emailSubject);
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (tabValue === "Cancel Unit") {
      getFormatedEmail("Cancel Unit")
        .then((resp) => {
          console.log("Cancel Unit", resp);
          setCancelUnit(resp.data[0].emailTemplate);
          setCancelUnitSubject(resp.data[0].emailSubject);
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (tabValue === "Blacklist Numbers") {
      getBlacklistedPhoneNumbers(pageNumber, false);
    } else if (tabValue === "Customer Portal Payment") {
      getCustomerPaymentMethodFun();

    }
    if (tabValue === "Dropdowns") {
      getNationalities();
      getAllWorksIn();
      getAllNatives();
      getAllBudgets();
    }
  }, [tabValue]);
  const [columns, setColumns] = useState([
    {
      field: "id",
      headerName: "Sr.No",
      width: 150,
      sortable: false,
    },

    {
      field: "number",
      headerName: "Phone Number",
      width: 200,
      sortable: false,
      renderCell: (params) => {
        return <div>+{params.row.number}</div>;
      },
    },
    {
      field: "CPName",
      headerName: "Name",
      width: 360,
      sortable: false,
      renderCell: (params) => {
        console.log(params.row.FosName);
        return (
          <div className={cssClasses.wrapperSecondColumn}>
            {params.row.FosName !== undefined ? (
              <div
                title={params.row.cpDisplayId}
                className={cssClasses.cpDisplayId}
              >
                {params.row.FosName}
              </div>
            ) : (
              <div
                title={params.row.cpDisplayId}
                className={cssClasses.cpDisplayId}
              >
                {params.row.CPName}
              </div>
            )}
            {params.row.FosName !== undefined ? (
              <LeadStatusChip
                style={{ color: "#0E7090", backgroundColor: "#ECFDFF" }}
                label={"FoS"}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            ) : (
              <LeadStatusChip
                style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                label={"CP"}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            )}
          </div>
        );
      },
    },
    // {
    //   field: "FosName",
    //   headerName: "FOS Name",
    //   width: 300,
    //   sortable: false,

    // },
    // {
    //   field: "UserName",
    //   headerName: "Sales Name",
    //   width: 250,
    //   sortable: false,

    // },
  ]);

  function getBlacklistedPhoneNumbers(pageNumber, merge) {
    getBlackListedPhoneNumber(
      pageNumber * pageSize,
      pageNumber * pageSize + pageSize - 1
    )
      .then((resp) => {
        resp.data = resp.data.map((each, index) => ({
          ...each,
          CPName: each?.cpId?.CpContactPerson[0]?.name,
          FosName: each?.fosId?.name,
          UserName: each?.userId?.name,
          id: blackListedList.length + index + 1,
        }));
        console.log(resp.data);
        if (merge) {
          setBlackListedList((pre) => [...pre, ...resp.data]);
        } else {
          setBlackListedList([...resp.data]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  function getMoreData(passPageNumber) {
    setPageNumber(passPageNumber);
    getBlacklistedPhoneNumbers(passPageNumber, true);
    // drpDownSelectedVal
  }
  const tabChange = (event, newValue) => {
    console.log(newValue);
    setTabValue(newValue);
  };
  function getNationalities() {
    getNationality()
      .then((resp) => {
        console.log(resp);
        setNationality([...resp.data]);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  function getAllWorksIn() {
    getWorksIn()
      .then((resp) => {
        console.log(resp);
        setWorksIn([...resp.data]);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  function getAllNatives() {
    getNative()
      .then((resp) => {
        console.log(resp);
        setNative([...resp.data]);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  function getAllBudgets() {
    getBudget()
      .then((resp) => {
        setBudget([...resp.data]);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function updateFormatedEmailFun(
    type,
    emailMessage,
    smsMessage,
    emailSubject
  ) {
    updateFormatedEmail(type, emailMessage, smsMessage, emailSubject)
      .then((resp) => {
        if (type === "Lead Onboarding") {
          successTost("Email Message for Lead onboarding Updated Successfully");
        } else if (type === "Pre Select Confirmation") {
          successTost(
            "Email Message for Pre Select Confirmation Updated Successfully"
          );
        } else if (type === "Cancel Unit") {
          successTost("Email Message for cancel unit Updated Successfully");
        }
      })
      .catch((err) => {
        console.log(err);
        errorTost(err.message);
      });
  }
  //   response from addDropDownlist if get the latest resp
  function returnRes(value) {
    if (value === "Nationality") {
      getNationalities();
    } else if (value === "Works In") {
      getAllWorksIn();
    } else if (value === "Native") {
      getAllNatives();
    } else if (value === "Budget") {
      getAllBudgets();
    }
  }

  function getCustomerPaymentMethodFun() {
    getCustomerPaymentMethod()
      .then((paymentMethodRes) => {
        console.log({ paymentMethodRes });
        setCustomerPayment((pre) => {
          pre.customerPaymentForToken = paymentMethodRes?.data[0]?.useLinkInCustomerAppForToken;
          pre.customerPaymentForAllotment = paymentMethodRes?.data[0]?.useLinkInCustomerAppForAllotment;
          pre.customerPaymentForBalanceSdr = paymentMethodRes?.data[0]?.useInAppForSdrPayment;
          return { ...pre }
        })
        //  if(paymentMethodRes.data[0].useLinkInCustomerAppForToken)
        // if (paymentMethodRes.data[0].useLinkInCustomerApp) {
        //   setCustomerPayment((pre)=>{
        //     pre.typeOfCustomerPayment='Payment Link';
        //     pre.currentTypeOfCustomerPayment='Payment Link';
        //     pre.id=paymentMethodRes.data[0].id
        //     return{...pre}
        //   });
        // } else {
        //   setCustomerPayment((pre)=>{
        //     pre.typeOfCustomerPayment='In-app Payment';
        //     pre.currentTypeOfCustomerPayment='In-app Payment';
        //     pre.id=paymentMethodRes.data[0].id
        //     return{...pre}
        //   });
        // }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const handleChange = (event) => {
    setChecked(event.target.checked);
    console.log('event.target.checked', event.target.checked);
  };
  function UpdatePaymentTypes() {
    console.log("customerPayment", customerPayment)
    let obj = {
      useLinkInCustomerAppForToken: customerPayment.customerPaymentForToken,
      useLinkInCustomerAppForAllotment: customerPayment.customerPaymentForAllotment,
      useInAppForSdrPayment: customerPayment.customerPaymentForBalanceSdr,
      useInAppForSlotBooking : checked
    }
    console.log("obj", obj)
    updateCustomerPaymentMethod(obj)
      .then((updatedRes) => {
        console.log(updatedRes);
        successTost('Customer Payment Method Updated Successfully');
        getCustomerPaymentMethodFun();
      })
      .catch((err) => {
        console.log(err);
        errorTost(err.message);
      });
  }
  const handleCommunicationTypeChange = (event) => {
    setCommunicationType(event.target.value);
  };

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleAddButtonClick = () => {
    if (inputValue.trim() !== '') {
      setAddedItems([...addedItems, { type: communicationType, value: inputValue }]);
      setInputValue('');
    }
  };
  return (
    <div className={cssClasses.wrapperPage}>
      <Tabs
        value={tabValue}
        onChange={tabChange}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
        sx={[
          {
            borderBottom: "1px solid #EAECF0 !important",
          },
        ]}
      >
        {tabList}
      </Tabs>

      <div className={cssClasses.wrapperContent}>
        {/* <div style={{width:'30%'}}>
      <Button
                  style={{
                    color: "#FFFFFF",
                    backgroundColor: "#155EEF",
                    fontSize: "1.6rem",
                    lineHeight: "2.4rem",
                  }}
                  btnName={"Update Transactions"}
                  disable={false}
                  clicked={() => {
                    updateAllAllotmentTransactions();
                 
                  }}
                />
      </div> */}
        {tabValue === "Lead Onboarding" && (
          <div className={cssClasses.wrapperSubContent}>
            <div className={cssClasses.containerSubContent}>
              {/* <div className={cssClasses.formatText}>
                Message Format Settings
              </div> */}
              {/* <div className={cssClasses.onBoardingTitle}>Lead Onboarding</div> */}
              <div className={cssClasses.wrapperText}>
                <div className={cssClasses.wrapperEmail}>
                  <div className={cssClasses.onBoardingTitle}>Email</div>
                  <div>
                    <CustomInput
                      value={leadOnBoardingSubject}
                      label={"Subject"}
                      mandatory={true}
                      handleChange={(newValue) => {
                        newValue = newValue.trimStart();
                        var alphabet = /^[A-Z*\sa-z]*$/;
                        if (newValue.match(alphabet) || newValue === "") {
                          if (newValue.length <= 40) {
                            setLeadOnBoardingSubject(newValue);
                          }
                        }
                        if (newValue !== "") {
                          setHelperText((pre) => {
                            pre.name = "";
                            return { ...pre };
                          });
                        } else {
                          helperText.name = "Please Enter Subject";
                        }
                      }}
                      placeholder="Enter Subject"
                      inputType="label"
                      helperText={helperText.name}
                    />
                  </div>
                  <div className={cssClasses.bodyTitle}>
                    Body <span style={{ color: "red" }}> *</span>
                  </div>
                  <div className={classes.wrapperCkeditor}>
                    <CKEditor
                      editor={ClassicEditor}
                      className={cssClasses.ck}
                      config={{
                        //    plugins: [Heading, 'Paragraph', 'Bold', 'Italic', 'Essentials','List' ],
                        toolbar: [
                          "paragraph",
                          "heading1",
                          "heading2",
                          "heading3",
                          "heading4",
                          "heading5",
                          "heading6",
                          "alignment",
                          "heading",
                          "|",
                          "bold",
                          "italic",
                          "link",
                          "bulletedList",
                          "numberedList",
                          "blockQuote",
                          "undo",
                          "redo",
                        ],
                      }}
                      data={leadOnBoardingMessage}
                      onReady={(editor) => {
                        // You can store the "editor" and use when it is needed.
                        console.log("Editor is ready to use!", editor);
                      }}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setLeadOnBoardingMessage(data);
                        // console.log({ event, editor, data });
                      }}
                      onBlur={(event, editor) => {
                        // console.log("Blur.", editor);
                      }}
                      onFocus={(event, editor) => {
                        // console.log("Focus.", editor);
                      }}
                    />
                  </div>
                </div>
                <div>
                  <Tooltip
                    title={
                      <h1 style={{ color: "lightblue" }}>
                        If you need to show lead name write it in this format{" "}
                        {`{{leadName}}`}
                      </h1>
                    }
                    disableInteractive
                    style={{ fontSize: "24px" }}
                  >
                    <InfoOutlinedIcon
                      style={{
                        fontSize: "2rem",
                        verticalAlign: "middle",
                        cursor: "pointer",
                      }}
                    />
                  </Tooltip>
                </div>
              </div>
            </div>
            <div className={cssClasses.buttonContainer}>
              <div className={cssClasses.wrapperButton}>
                <Button
                  style={{
                    color: "#FFFFFF",
                    backgroundColor: "#155EEF",
                    fontSize: "1.6rem",
                    lineHeight: "2.4rem",
                  }}
                  btnName={"Update"}
                  disable={
                    leadOnBoardingMessage === "" || leadOnBoardingSubject === ""
                  }
                  clicked={() => {
                    updateFormatedEmailFun(
                      "Lead Onboarding",
                      leadOnBoardingMessage,
                      null,
                      leadOnBoardingSubject
                    );
                  }}
                />
              </div>
            </div>
          </div>
        )}
        {tabValue === "Pre Select Confirmation" && (
          <div className={cssClasses.wrapperSubContent}>
            <div className={cssClasses.containerSubContent}>
              {/* <div className={cssClasses.formatText}>
                Message Format Settings
              </div>
              <div className={cssClasses.onBoardingTitle}>
                Pre Select Confirmation
              </div> */}
              <div className={cssClasses.wrapperText}>
                <div className={cssClasses.wrapperEmail}>
                  <div className={cssClasses.onBoardingTitle}>Email</div>
                  <div>
                    <CustomInput
                      value={preSelectConfirmationSubject}
                      label={"Subject"}
                      mandatory={true}
                      handleChange={(newValue) => {
                        newValue = newValue.trimStart();
                        var alphabet = /^[A-Z*\sa-z]*$/;
                        if (newValue.match(alphabet) || newValue === "") {
                          if (newValue.length <= 40) {
                            setPreSelectConfirmationSubject(newValue);
                          }
                        }
                        if (newValue !== "") {
                          setHelperText((pre) => {
                            pre.name = "";
                            return { ...pre };
                          });
                        } else {
                          helperText.name = "Please Enter Subject";
                        }
                      }}
                      placeholder="Enter Subject"
                      inputType="label"
                      helperText={helperText.name}
                    />
                  </div>
                  <div className={cssClasses.bodyTitle}>
                    Body <span style={{ color: "red" }}> *</span>
                  </div>
                  <div className={classes.wrapperCkeditor}>
                    <CKEditor
                      className={classes.ck}
                      editor={ClassicEditor}
                      config={{
                        //    plugins: [Heading, 'Paragraph', 'Bold', 'Italic', 'Essentials','List' ],
                        toolbar: [
                          "paragraph",
                          "heading1",
                          "heading2",
                          "heading3",
                          "heading4",
                          "heading5",
                          "heading6",
                          "alignment",
                          "heading",
                          "|",
                          "bold",
                          "italic",
                          "link",
                          "bulletedList",
                          "numberedList",
                          "blockQuote",
                          "undo",
                          "redo",
                        ],
                      }}
                      data={preSelectConfirmation}
                      onReady={(editor) => {
                        // You can store the "editor" and use when it is needed.
                        console.log("Editor is ready to use!", editor);
                      }}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setPreSelectConfirmation(data);
                        // console.log({ event, editor, data });
                      }}
                      onBlur={(event, editor) => {
                        // console.log("Blur.", editor);
                      }}
                      onFocus={(event, editor) => {
                        // console.log("Focus.", editor);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className={cssClasses.buttonContainer}>
              <div className={cssClasses.wrapperButton}>
                <Button
                  style={{
                    color: "#FFFFFF",
                    backgroundColor: "#155EEF",
                    fontSize: "1.6rem",
                    lineHeight: "2.4rem",
                  }}
                  btnName={"Update"}
                  disable={
                    preSelectConfirmation === "" ||
                    preSelectConfirmationSubject === ""
                  }
                  clicked={() => {
                    updateFormatedEmailFun(
                      "Pre Select Confirmation",
                      preSelectConfirmation,
                      null,
                      preSelectConfirmationSubject
                    );
                  }}
                />
              </div>
            </div>
          </div>
        )}
        {tabValue === "Cancel Unit" && (
          <div className={cssClasses.wrapperSubContent}>
            <div className={cssClasses.containerSubContent}>
              {/* <div className={cssClasses.formatText}>
                Message Format Settings
              </div>
              <div className={cssClasses.onBoardingTitle}>Cancel Unit</div> */}
              <div className={cssClasses.wrapperText}>
                <div className={cssClasses.wrapperEmail}>
                  <div className={cssClasses.onBoardingTitle}>Email</div>
                  <div>
                    <CustomInput
                      value={cancelUnitSubject}
                      label={"Subject"}
                      mandatory={true}
                      handleChange={(newValue) => {
                        newValue = newValue.trimStart();
                        var alphabet = /^[A-Z*\sa-z]*$/;
                        if (newValue.match(alphabet) || newValue === "") {
                          if (newValue.length <= 40) {
                            setCancelUnitSubject(newValue);
                          }
                        }
                        if (newValue !== "") {
                          setHelperText((pre) => {
                            pre.name = "";
                            return { ...pre };
                          });
                        } else {
                          helperText.name = "Please Enter Subject";
                        }
                      }}
                      placeholder="Enter Subject"
                      inputType="label"
                      helperText={helperText.name}
                    />
                  </div>
                  <div className={cssClasses.bodyTitle}>
                    Body <span style={{ color: "red" }}> *</span>
                  </div>
                  <div className={classes.wrapperCkeditor}>
                    <CKEditor
                      editor={ClassicEditor}
                      config={{
                        //    plugins: [Heading, 'Paragraph', 'Bold', 'Italic', 'Essentials','List' ],
                        toolbar: [
                          "paragraph",
                          "heading1",
                          "heading2",
                          "heading3",
                          "heading4",
                          "heading5",
                          "heading6",
                          "alignment",
                          "heading",
                          "|",
                          "bold",
                          "italic",
                          "link",
                          "bulletedList",
                          "numberedList",
                          "blockQuote",
                          "undo",
                          "redo",
                        ],
                      }}
                      data={cancelUnit}
                      onReady={(editor) => {
                        // You can store the "editor" and use when it is needed.
                        console.log("Editor is ready to use!", editor);
                      }}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setCancelUnit(data);
                        console.log({ event, editor, data });
                      }}
                      onBlur={(event, editor) => {
                        // console.log("Blur.", editor);
                      }}
                      onFocus={(event, editor) => {
                        // console.log("Focus.", editor);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className={cssClasses.buttonContainer}>
              <div className={cssClasses.wrapperButton}>
                <Button
                  style={{
                    color: "#FFFFFF",
                    backgroundColor: "#155EEF",
                    fontSize: "1.6rem",
                    lineHeight: "2.4rem",
                  }}
                  btnName={"Update"}
                  disable={cancelUnit === "" || cancelUnitSubject === ""}
                  clicked={() => {
                    updateFormatedEmailFun(
                      "Cancel Unit",
                      cancelUnit,
                      null,
                      cancelUnitSubject
                    );
                  }}
                />
              </div>
            </div>
          </div>
        )}
        {tabValue === "Dropdowns" && (
          <div className={cssClasses.wrapperSubContent}>
            <div className={cssClasses.onBoardingTitle}>All Dropdowns</div>
            <div className={cssClasses.wrapperBlocks}>
              <div style={{ width: "50%", paddingLeft: "0.3rem" }}>
                <div className={cssClasses.blockLabel}>
                  Nationality Preview <span style={{ color: "red" }}> *</span>
                </div>
                <div style={{ width: "100%" }}>
                  <DropDown
                    list={nationality.map((element, index) => {
                      return {
                        label: element.nationality,
                        value: element.nationalityId,
                        isEdit: true,
                        isDelete: true,
                      };
                    })}
                    // selectedValue={''}
                    onChangeSelect={() => { }}
                    onChangeEdit={(value) => {
                      console.log(value);
                      let selectedValue = nationality.filter(
                        ({ nationalityId }) => nationalityId === value
                      );
                      setData(selectedValue[0]);
                      console.log("editable");
                      setType("Edit");
                      setTitle("Nationality");
                      setAddDropDownModal(true);
                    }}
                    onChangeDelete={(value) => {
                      let selectedValue = nationality.filter(
                        ({ nationalityId }) => nationalityId === value
                      );
                      setData(selectedValue[0]);
                      setTitle("Nationality");
                      setDisplayDeleteTitle("Alert !");
                      setDisplayDeleteSubTitle(
                        `Are you sure you want to delete ${selectedValue[0].nationality} dropdown value.`
                      );
                      setOpenConfirmation(true);
                    }}
                    placeHolder={"Select"}
                    //style.color is placeHolder's color
                    style={{
                      background: "#F2F4F7",
                      color: "rgb(102, 112, 133)",
                    }}
                  />
                </div>
              </div>
              <div className={cssClasses.wrapperButton}>
                <Button
                  style={{
                    color: "#FFFFFF",
                    backgroundColor: "#155EEF",
                    fontSize: "1.6rem",
                    lineHeight: "2.4rem",
                  }}
                  btnName={"Add Field"}
                  btnIcon={<PlusIcon />}
                  iconPosition={"left"}
                  disable={helperText.cancelUnit !== ""}
                  clicked={() => {
                    setAddDropDownModal(true);
                    setType("Add");
                    setTitle("Nationality");
                  }}
                />
              </div>
            </div>
            <div className={cssClasses.wrapperBlocks}>
              <div style={{ width: "50%", paddingLeft: "0.3rem" }}>
                <div className={cssClasses.blockLabel}>
                  Native Preview <span style={{ color: "red" }}> *</span>
                </div>
                <div style={{ width: "100%" }}>
                  <DropDown
                    list={native.map((element, id) => {
                      return {
                        label: element.native,
                        value: element.nativeId,
                        isEdit: true,
                        isDelete: true,
                      };
                    })}
                    onChangeSelect={() => { }}
                    // selectedValue={''}
                    onChangeEdit={(value) => {
                      let selectedValue = native.filter(
                        ({ nativeId }) => nativeId === value
                      );
                      setData(selectedValue[0]);
                      setType("Edit");
                      setTitle("Native");
                      setAddDropDownModal(true);
                    }}
                    onChangeDelete={(value) => {
                      let selectedValue = native.filter(
                        ({ nativeId }) => nativeId === value
                      );
                      setData(selectedValue[0]);
                      setTitle("Native");
                      setDisplayDeleteTitle("Alert !");
                      setDisplayDeleteSubTitle(
                        `Are you sure you want to delete ${selectedValue[0].native} dropdown value.`
                      );
                      setOpenConfirmation(true);
                    }}
                    placeHolder={"Select"}
                    style={{
                      background: "#F2F4F7",
                      color: "rgb(102, 112, 133)",
                    }}
                  />
                </div>
              </div>
              <div className={cssClasses.wrapperButton}>
                <Button
                  style={{
                    color: "#FFFFFF",
                    backgroundColor: "#155EEF",
                    fontSize: "1.6rem",
                    lineHeight: "2.4rem",
                  }}
                  btnName={"Add Field"}
                  btnIcon={<PlusIcon />}
                  iconPosition={"left"}
                  disable={helperText.cancelUnit !== ""}
                  clicked={() => {
                    setAddDropDownModal(true);
                    setType("Add");
                    setTitle("Native");
                  }}
                />
              </div>
            </div>
            <div className={cssClasses.wrapperBlocks}>
              <div style={{ width: "50%", paddingLeft: "0.3rem" }}>
                <div className={cssClasses.blockLabel}>
                  Works In Preview <span style={{ color: "red" }}> *</span>
                </div>
                <div style={{ width: "100%" }}>
                  <DropDown
                    list={worksIn.map((element, id) => {
                      return {
                        label: element.profession,
                        value: element.professionId,
                        isEdit: true,
                        isDelete: true,
                      };
                    })}
                    // selectedValue={''}
                    onChangeSelect={() => { }}
                    onChangeEdit={(value) => {
                      console.log(value);
                      let selectedValue = worksIn.filter(
                        ({ professionId }) => professionId === value
                      );
                      setData(selectedValue[0]);
                      setType("Edit");
                      setTitle("Works In");
                      setAddDropDownModal(true);
                    }}
                    onChangeDelete={(value) => {
                      let selectedValue = worksIn.filter(
                        ({ professionId }) => professionId === value
                      );
                      setOpenConfirmation(true);
                      setData(selectedValue[0]);
                      setTitle("Works In");
                      setDisplayDeleteTitle("Alert !");
                      setDisplayDeleteSubTitle(
                        `Are you sure you want to delete ${selectedValue[0].profession} dropdown value.`
                      );
                    }}
                    placeHolder={"Select"}
                    //style.color is placeHolder's color
                    style={{
                      background: "#F2F4F7",
                      color: "rgb(102, 112, 133)",
                    }}
                  />
                </div>
              </div>
              <div className={cssClasses.wrapperButton}>
                <Button
                  style={{
                    color: "#FFFFFF",
                    backgroundColor: "#155EEF",
                    fontSize: "1.6rem",
                    lineHeight: "2.4rem",
                  }}
                  btnName={"Add Field"}
                  btnIcon={<PlusIcon />}
                  iconPosition={"left"}
                  disable={helperText.cancelUnit !== ""}
                  clicked={() => {
                    setAddDropDownModal(true);
                    setType("Add");
                    setTitle("Works In");
                  }}
                />
              </div>
            </div>
             <div className={cssClasses.wrapperBlocks}>
              <div style={{ width: "50%", paddingLeft: "0.3rem" }}>
                <div className={cssClasses.blockLabel}>
                  Budget Preview <span style={{ color: "red" }}> *</span>
                </div>
                <div style={{ width: "100%" }}>
                  <DropDown
                    list={budget.map((element, id) => {
                      return {
                        label: element.budget,
                        value: element.budgetId,
                        isEdit: true,
                        isDelete: true,
                      };
                    })}
                    onChangeSelect={() => { }}
                    onChangeEdit={(value) => {
                      let selectedValue = budget.filter(
                        ({ budgetId }) => budgetId === value
                      );
                      setData(selectedValue[0]);
                      setType("Edit");
                      setTitle("Budget");
                      setAddDropDownModal(true);
                    }}
                    onChangeDelete={(value) => {
                      let selectedValue = budget.filter(
                        ({ budgetId }) => budgetId === value
                      );
                      setData(selectedValue[0]);
                      setTitle("Budget");
                      setDisplayDeleteTitle("Alert !");
                      setDisplayDeleteSubTitle(
                        `Are you sure you want to delete ${selectedValue[0].budget} dropdown value.`
                      );
                      setOpenConfirmation(true);
                    }}
                    placeHolder={"Select"}
                    style={{
                      background: "#F2F4F7",
                      color: "rgb(102, 112, 133)",
                    }}
                  />
                </div>
              </div>
              <div className={cssClasses.wrapperButton}>
                <Button
                  style={{
                    color: "#FFFFFF",
                    backgroundColor: "#155EEF",
                    fontSize: "1.6rem",
                    lineHeight: "2.4rem",
                  }}
                  btnName={"Add Field"}
                  btnIcon={<PlusIcon />}
                  iconPosition={"left"}
                  disable={helperText.cancelUnit !== ""}
                  clicked={() => {
                    setAddDropDownModal(true);
                    setType("Add");
                    setTitle("Budget");
                  }}
                />
              </div>
            </div>
          </div>
        )}
        {tabValue === "Blacklist Numbers" && (
          <div className={cssClasses.wrapperBlackListedNumbers}>
            <div className={cssClasses.onBoardingTitle}>
              Blacklisted Numbers
            </div>
            <div className={cssClasses.wrapperTable}>
              <DataGrid
                rows={blackListedList}
                columns={columns}
                pageSize={10}
                page={pageMaintain}
                onPageChange={(_page) => {
                  console.log(_page);
                  setPageMaintain(_page);
                  if (pageNumber < _page) {
                    getMoreData(_page);
                    setPageNumber(_page);
                  }
                }}
                sx={[dataGridStyles]}
              />
            </div>
          </div>
        )}
        {tabValue === "Customer Portal Payment" && (
          <div className={cssClasses.wrapperSubContent} style={{
            width: '99%',
            margin: '0 auto'
          }}>
            <div div className={cssClasses.containerSubContent}>
              <div
                className={cssClasses.onBoardingTitle}
                style={{ paddingTop: "1rem" }}
              >
                Customer Portal Payment Configuration:
              </div>
              <div className={cssClasses.toggleLabel}>
                Token Payment method:
              </div>
              <div>
                <CustomRadio
                  optionList={["Payment Link", "In-app Payment"]}
                  onChangeValue={(_value) => {
                    console.log("Token-payment", _value)
                    if (_value === 'Payment Link') {
                      setCustomerPayment((pre) => {
                        pre.customerPaymentForToken = true;
                        return { ...pre };
                      })
                    } else {
                      setCustomerPayment((pre) => {
                        pre.customerPaymentForToken = false;
                        return { ...pre };
                      })
                    }
                  }}
                  value={customerPayment.customerPaymentForToken ? "Payment Link" : "In-app Payment"}
                />
              </div>
              <div className={cssClasses.toggleLabel}>
                Allotment Payment method:
              </div>
              <div>
                <CustomRadio
                  optionList={["Payment Link", "In-app Payment"]}
                  onChangeValue={(_value) => {
                    console.log("Allotment-payment", _value)
                    if (_value === 'Payment Link') {
                      setCustomerPayment((pre) => {
                        pre.customerPaymentForAllotment = true;
                        return { ...pre };
                      })
                    } else {
                      setCustomerPayment((pre) => {
                        pre.customerPaymentForAllotment = false;
                        return { ...pre };
                      })
                    }
                  }}
                  value={customerPayment.customerPaymentForAllotment ? "Payment Link" : "In-app Payment"}
                />
              </div>
              <div className={cssClasses.toggleLabel}>
                Balance SDR  Payment method:
              </div>
              <div>

                <FormGroup sx={{ display: "flex", flexDirection: "row" }}>
                  <FormControlLabel
                    control={<Checkbox
                      tabIndex="0"
                      sx={{
                        '&.Mui-checked': {
                          color: "#175CD3",
                        },
                      }}
                      disabled
                      checked />
                    }
                    label={"Virtual Account"}
                    sx={[radioButtonStyle]}
                  />
                  <FormControlLabel
                    control={<Checkbox
                      tabIndex="0"
                      sx={{
                        '&.Mui-checked': {
                          color: "#175CD3",
                        },
                      }}
                      checked={customerPayment.customerPaymentForBalanceSdr}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setCustomerPayment((pre) => {
                            pre.customerPaymentForBalanceSdr = true;
                            return { ...pre };
                          })
                        } else {
                          setCustomerPayment((pre) => {
                            pre.customerPaymentForBalanceSdr = false;
                            return { ...pre };
                          })
                        }

                      }} />
                    }
                    label={"In-app Payment"}
                    sx={[radioButtonStyle]}
                  />


                </FormGroup>
              </div>
              <div className={cssClasses.toggleLabel}>
                Customer Portal Slot Booking Configuration:
              </div>
              <div style={{ display: "flex", alignItems: 'center' }}>
                <div className={cssClasses.toggleSubLabel}>
                  Can customer book a slot?
                </div>
                <Box
                  width={'fit-content'}
                  margin={'1rem 2rem'}
                  display={'flex'}
                  flexDirection={'row'}
                  gap={'0.5rem'}
                >
                  <Box mr={1} mt={0.3} className={cssClasses.customSwitchLabel}>
                    No
                  </Box>
                  <CustomSwitch checked={checked} onChange={handleChange} />
                  <Box ml={1} mt={0.3} className={cssClasses.customSwitchLabel}>
                    Yes
                  </Box>
                </Box>
              </div>
            </div>
            <div className={cssClasses.buttonContainer}>
              <div className={cssClasses.wrapperButton}>
                <Button
                  style={{
                    color: "#FFFFFF",
                    backgroundColor: "#155EEF",
                    fontSize: "1.6rem",
                    lineHeight: "2.4rem",
                  }}
                  btnName={"Update"}
                  //  disable={customerPayment.typeOfCustomerPayment===customerPayment.currentTypeOfCustomerPayment}
                  clicked={() => {
                    UpdatePaymentTypes()
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
      {addDropDownModal && (
        <AddDropDownList
          open={addDropDownModal}
          handleClose={() => {
            setAddDropDownModal(false);
          }}
          passData={data}
          returnRes={returnRes}
          title={title}
          type={type}
        />
      )}
      <ConfirmationAlert
        open={openConfirmation}
        close={() => {
          setOpenConfirmation(false);
        }}
        icon={<Info width={"4.8rem"} height={"4.8rem"} />}
        title={displayDeleteTitle}
        subTitle={displayDeleteSubTitle}
        confirm={(value) => {
          if (value === "confirmed") {
            if (title === "Nationality") {
              deleteNationality(data?.nationalityId)
                .then((resp) => {
                  console.log(resp);
                  successTost(
                    `${data?.nationality} dropdown value has been deleted successfully`
                  );
                  getNationalities();
                })
                .catch((err) => {
                  console.log(err);
                  if (
                    err.message.includes(
                      'update or delete on table "Nationality" violates foreign key constraint'
                    )
                  ) {
                    errorTost(
                      "This Nationality is already selected.You need to delete from Database"
                    );
                  } else {
                    errorTost(err.message);
                  }
                });
            } else if (title === "Works In") {
              deleteWorksIn(data?.professionId)
                .then((resp) => {
                  console.log(resp);
                  successTost(
                    `${data?.profession} dropdown value has been deleted successfully`
                  );
                  getAllWorksIn();
                })
                .catch((err) => {
                  if (
                    err.message.includes(
                      'update or delete on table "Professions" violates foreign key constraint'
                    )
                  ) {
                    errorTost(
                      "This WorksIn is already selected.You need to delete from Database"
                    );
                  } else {
                    errorTost(err.message);
                  }
                });
            } else if (title === "Native") {
              deleteNative(data?.nativeId)
                .then((resp) => {
                  console.log(resp);
                  successTost(
                    `${data?.native} dropdown value has been deleted successfully`
                  );
                  getAllNatives();
                })
                .catch((err) => {
                  console.log(err);
                  if (
                    err.message.includes(
                      'update or delete on table "Native" violates foreign key constraint'
                    )
                  ) {
                    errorTost(
                      "This Native is already selected.You need to delete from Database"
                    );
                  } else {
                    errorTost(err.message);
                  }
                });
            } else if (title === "Budget") {
              deleteBudget(data?.budgetId)
                .then((resp) => {
                  successTost(
                    `${data?.budget} dropdown value has been deleted successfully`
                  );
                  getAllBudgets();
                })
                .catch((err) => {
                  if (
                    err.message.includes(
                      'update or delete on table "Budget" violates foreign key constraint'
                    )
                  ) {
                    errorTost(
                      "This Budget is already selected.You need to delete from Database"
                    );
                  } else {
                    errorTost(err.message);
                  }
                });
            }
            setOpenConfirmation(false);
          } else if (value === "rejected") {
            setOpenConfirmation(false);
          }
        }}
        buttonTitle={"No"}
        returnRespButton={"Yes"}
      />
    </div>
  );
}
